import { render, staticRenderFns } from "./logo-text.vue?vue&type=template&id=79dc8bcb&scoped=true&"
import script from "./logo-text.vue?vue&type=script&lang=js&"
export * from "./logo-text.vue?vue&type=script&lang=js&"
import style0 from "./logo-text.vue?vue&type=style&index=0&id=79dc8bcb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc8bcb",
  null
  
)

export default component.exports